import moment from 'moment';

function formatDate(dateString, uppercase = true) {
  if (!dateString) {
    dateString = new Date();
  }

  const date = moment(dateString).format('MMM DD, YYYY');

  if (uppercase) {
    return date.toUpperCase();
  }

  return date;
}

export default formatDate;
